import React, { useEffect, useState } from "react";
import Input from "sushiweb/InputTypes/Input";
import styled from "styled-components";
import Button from "sushiweb/Button";
import { useLocation } from "react-router-dom";

const InputBar = ({ handleSubmit }) => {
  const [fe_id, setFEID] = useState("");

  const onChange = (val) => {
    setFEID(val);
  };

  const onSubmit = (evt) => {
    evt.preventDefault();
    handleSubmit(fe_id);
  };
  return (
    <InputBarFormContainer className="actionBar flex items-start">
      <Input
        className="mr-10"
        value={fe_id}
        autoFocus={true}
        data-testid="assetIssuanceInput"
        label="FE ID"
        onChange={(val) => onChange(val)}
        id="sushi-input"
      />
      <Button
        className="sushi-btn"
        appearance="outline"
        data-testid="assetIssuanceSubmitBtn"
        onClick={onSubmit}
      >
        Search
      </Button>
    </InputBarFormContainer>
  );
};

const InputBarFormContainer = styled.div`
  #sushi-input {
    margin-bottom: unset !important;
  }
`;

export default InputBar;
